import {
    deliveryModeId,
    onlineNatureId,
    detailLocations,
} from '../shared/programRequestDetailsModel';

export const createChangeDetailsModel = () => ({
    institutionId: null,
    programId: null,
    programName: '',
    cipCode: null,
    degreeLevel: null,
    creditMin: '',
    creditMax: '',
    deliveryMode: null,
    onlineNature: null,
    locations: [],
    comments: '',
});

export const createChangeDetailsEditModel = details => ({
    institutionId: details?.institutionId ?? null,
    programId: Number(details?.programID ?? details?.programId) || null,
    programName: details?.programName ?? '',
    cipCode: details?.cipCode ?? null,
    degreeLevel: details?.degreeLevelId ?? null,
    creditMin: details?.creditRequirementMinimum ?? '',
    creditMax: details?.creditRequirementMaximum ?? '',
    deliveryMode: deliveryModeId(details?.deliveryMode),
    onlineNature: onlineNatureId(details?.deliveryModeOnline),
    locations: detailLocations(details),
    comments: '',
});

const normalizeNumber = value =>
    value === '' || value === null || value === undefined ? null : Number(value);

export const toCreateChangeDetailsRequest = form => ({
    institutionId: form.institutionId,
    programId: form.programId,
    formalName: form.programName.trim(),
    cipCode: form.cipCode,
    degreeLevel: form.degreeLevel,
    distanceEdApproved: { id: Number(form.deliveryMode) },
    distanceEdOnline: { id: Number(form.onlineNature ?? 0) },
    creditRequirementMinimum: normalizeNumber(form.creditMin),
    creditRequirementMaximum: normalizeNumber(form.creditMax),
    locationStatusChanges: form.locations.map(location => ({
        locationId: location.value,
        statusId: Number(location.statusId),
    })),
    comments: form.comments.trim() || null,
});

export const toEditChangeDetailsRequest = (form, details) => ({
    ...toCreateChangeDetailsRequest(form),
    requestId: details?.requestID ?? details?.requestId,
});
